import SatisfactionSummaryModule from './containers/satisfactionSummaryModule'

export {default as SatisfactionSummaryModuleLayout} from './components/satisfactionSummaryModuleLayout'

export default SatisfactionSummaryModule
